<template>
  <section>
    <v-layout row style="width: 88%;margin: auto;">
      <v-data-table :headers="headers"
                    :items="GetBanners"
                    item-key="Banner_Text"
                    class="elevation-1"
                    style="width:100%;margin-top:10px;">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.Banner_Text }}</td>
            <td class="text-xs-center">
              <img :src="props.item.Banner_Image" style="height: 115px;width: 150px;" />
            </td>
            <td class="text-xs-center">{{ props.item.Banner_Position }}</td>
            <td class="text-xs-center">
              <v-btn color="primary" icon class="btnAction" @click="OpenUpdateBannerModal(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn color="error" icon class="btnAction" @click="DeleteBanner(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
    <app-update-banner ref="UpdateBanner" :dialog="UpdateBanner" @close="CloseDialog"></app-update-banner>
  </section>
</template>
<script>
import appUpdateBanner from "../dialogs/AddBanner";
export default {
  components: {
    appUpdateBanner
  },
  data() {
    return {
      headers: [
        { text: "Banner Text", value: "Banner_Text" },
        { text: "Banner Image", value: "Banner_Image" },
        { text: "Banner Position", value: "Banner_Position" },
        { text: "Actions" }
      ],
      Banners: [],
      UpdateBanner: false
    };
  },
  computed: {
    GetBanners() {
      return this.$store.getters.GetBanners;
    }
  },
  methods: {
    OpenUpdateBannerModal(Banner) {
      this.UpdateBanner = true;
      this.$refs.UpdateBanner.UpdateBanner(Banner);
    },
    DeleteBanner(Banner) {
      if (confirm("Do you really want to delete?")) {
      
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/banners/deletebanner`,
            Banner
          )
          .then(response => {
            this.$store.commit(
              "DeleteIndividualBanner",
              response["data"]["response"]
            );
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Successfully Deleted Banner Image",
              Color: "green",
              Close: false
            });
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Error Banner Image",
              Color: "red",
              Close: false
            });
          });
      }
    },
    CloseDialog() {
      this.UpdateBanner = false;
    }
  },
  mounted() {
    this.$store.commit("SetLoading", true);
    
    this.$http
      .post(`${this.$store.getters.GetProductionUrl}/banners/getbanners`)
      .then(response => {
        this.$store.commit("SetBanners", response["data"]["response"]);
        this.$store.commit("SetLoading", false);
      })
      .catch(err => {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Error While Fetching Data",
          Color: "red",
          Close: false
        });
      });
  }
};
</script>
<style scoped>
</style>


